import { motion, AnimatePresence } from 'framer-motion';
import classNames from 'classnames';
import useCDNI from '../../hooks/useCDNI';
import Modal from '../modal/modal';
import useContentForBuild from '../../hooks/useContentForBuild';

export type ErrorMessage = {
  cta?: string;
  cdniExit?: any;
  exit?: any;
  goToSettingsCta?: string;
  heading: string;
  message: string;
  persistOnExit?: boolean;
};

type ErrorModalComponent = {
  error: ErrorMessage | null;
};

export default function ErrorModal({ error }: ErrorModalComponent) {
  const [content] = useContentForBuild();
  const { openDeviceStorage, fireExit } = useCDNI(content);

  return (
    <AnimatePresence>
      {!!error && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <Modal additionalClass="frame--nomin" hasExit={false}>
            <div className="error">
              <h3>{error.heading}</h3>
              <p>{error.message}</p>
              <div className="error__ctas">
                {error.goToSettingsCta && (
                  <button className="cta cta--margin-right cta--full" onClick={() => openDeviceStorage()}>
                    {error.goToSettingsCta}
                  </button>
                )}
                {error.cdniExit && error.cta && (
                  <button className={classNames('cta', error.goToSettingsCta && 'cta--full')} onClick={() => fireExit()}>
                    {error.cta}
                  </button>
                )}
                {error.exit && error.cta && (
                  <button className="cta" onClick={error.exit}>
                    {error.cta}
                  </button>
                )}
              </div>
            </div>
          </Modal>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
